export interface SlackIntegrationOutputApiModel {
    id: number;
    config: SlackIntegrationConfigOutputApiModel;
}
export interface SlackIntegrationConfigOutputApiModel {
    access_token: string;
    channel_id: string;
}